module.exports = __webpack_public_path__ + "img/sack-money-globe.989c138e.svg";